import React from 'react'

import SelectAnesthesiologyLayout from 'presentation/doctor/layouts/AddSurgicalOrderNew/SelectAnesthesiology'

const SelectAnesthesiology = () => <SelectAnesthesiologyLayout />

export default SelectAnesthesiology
